import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CanActivateService } from './services/common/can.active.service';
// import { Error404Component } from './shared/errors/error404/error404.component';
// import { Error500Component } from './shared/errors/error500/error500.component';
// import { Error401Component } from './shared/errors/error401/error401.component';
import { TemplateComponent } from './shared/template/template.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'transporteMaritimo',
    pathMatch: 'full'
  },
  {
    path: '',
    component: TemplateComponent,
    children: [
      {
        path: 'transporteMaritimo',
        loadChildren: () => import("./modules/general/general.module").then(module => module.GeneralModule),
        canActivate: ['CanAlwaysActivateGuard', CanActivateService]
      },
    ]
  },
//   {
//     path: 'error500',
//     component: Error500Component
//   },
//   {
//     path: 'error404',
//     component: Error404Component
//   },
//   {
//     path: 'error401',
//     component: Error401Component
//   },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
  useHash: true, onSameUrlNavigation: 'reload',
  anchorScrolling: 'enabled',
  enableTracing: false
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
